import _find from "lodash/find";
import _isUndefined from "lodash/isUndefined";
import _first from "lodash/first";
export function findCascadeOption(options, value, defaultFirst = false) {
    const option = _find(options, (option) => option.value === value);
    return _isUndefined(option) && defaultFirst ? _first(options) : option;
}
